<script type="ts">
    import type { IBillingDocument } from '../models/backend';
    import LoadingProgress from './design/LoadingProgress.svelte';
    import { onMount } from 'svelte';
    import { downloadAuthenticatedFile, getAuthenticatedData } from '../services/MyNemiServices';
    import axios from 'axios';

    let invoices: IBillingDocument[];

    onMount(() =>
    {
        getAuthenticatedData<IBillingDocument[]>('/umbraco/api/mynemi/getinvoices')
            .then((response) => invoices = response.data);
    });

    function getTypeDescription(type: string)
    {
        switch (type)
        {
            case 'stripe' :
                return 'Fature E-Learning';
        }

        return type;
    }

    function handleDownload(id: string)
    {
        downloadAuthenticatedFile('/umbraco/api/mynemi/downloadstripedocument?documentId=' + id, id + '.pdf');
    }
</script>

<div class="row">
    <div class="col"><h4>Vos factures</h4></div>
</div>

{#if !invoices}
    <LoadingProgress/>
{:else }
    <div class="row">
        <div class="col">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Type</th>
                        <th scope="col">Référence</th>
                        <th scope="col">Montant</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each invoices as invoice}
                        <tr>
                            <td>{invoice.billingDate}</td>
                            <td>{getTypeDescription(invoice.type)}</td>
                            <td>{invoice.reference}</td>
                            <td>{invoice.amount.toFixed(2)} &euro;</td>
                            <td><a href={'#'} on:click={() => handleDownload(invoice.id)}>Télecharger</a></td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
{/if}